import "../../theme/SpeechStyle.css";

import {Box, Center, Container, IconButton, Image, Spinner, useToast} from "@chakra-ui/react";
import React, {memo, useEffect, useRef} from "react";
import {IoHome} from "react-icons/io5";
import {useQuery} from "react-query";
import {useNavigate, useParams} from "react-router-dom";

import {getAutomatedTest} from "../../shared/Api";
import {errorToast} from "../../shared/helper/ToastHelper";
import {disableBlurProtection, enableBlurProtection} from "../../shared/hooks/BlurProtection";
import {useTheme} from "../../shared/hooks/ThemeProvider";
import {customButtonProps, Paths, SkillType} from "../../shared/model/Constants";
import {publicKeys} from "../../shared/QueryKeys";
import {
  disableKeyCommands,
  extractData, isDemo, isInAvataiSite
} from "../../shared/Utils";

const AutomatedTest = () => {
  const theme = useTheme().theme;
  const toast = useToast();
  const navigate = useNavigate();

  const params = useParams<{
    skillType: string;
  }>();
  const skillType = params.skillType || "";

  const demoMode = isDemo();
  const testQuery = useQuery(publicKeys.testByType(skillType), () =>
  { return getAutomatedTest(skillType as SkillType, demoMode).then(extractData); });

  useEffect(() => {
    const onBeforeUnload = (ev:any) => {
      ev.returnValue = "ret";
      return "ret";
    };
    window.addEventListener("beforeunload", onBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, []);

  disableKeyCommands();

  const testId = skillType;
  const iframe = useRef<HTMLElement>();
  iframe.current = document.getElementById(testId) || undefined;
  useEffect(() => {
    iframe.current = document.getElementById(testId) || undefined;
    if (iframe.current !== undefined) {
      disableBlurProtection();
      enableBlurProtection(iframe.current, false);
    }
  }, [])

  const html = document.getElementsByTagName("html").item(0);
  if (html !== null) html.style.height="100%";
  const container = document.getElementById("container");
  if (container !== null) container.style.height="100%";

  function navigateHome() {
    navigate(Paths.HOME);
  }

  if (testQuery.data==="") {
    errorToast(toast, "No se encontró una prueba asociada");
    navigateHome();
    return (<></>);
  } else
  if (!testQuery.data) {
    return (
      <Center height="200px">
        <Spinner />
      </Center>
    );
  } else
  return (
    <Container maxW="container.lg" marginX="auto" height="100%" boxSizing="content-box"
          filter= {'grayscale('+theme.IMG_GRAYSCALE+') contrast('+theme.IMG_CONTRAST+')'}>
      <Box boxSizing="content-box"
          bgImage="'/images/img-1e0eab8174642bd1921638f9bd71e94648399338.png'"
          bgSize= "cover" bgRepeat= "no-repeat"
          minHeight="610px"  width="100%" height="100%"
          borderWidth='1px' borderRadius='lg'>

        <Container boxSizing="content-box"
                   height="100%" paddingTop="1rem" maxW="95%">
          <iframe id={testId} style={{border: 'none'}}
                  width='100%' height='95%' allow='camera;microphone'
                  title={testId} src={testQuery.data}
          />{/*
                      <Center paddingTop={10}>
                        <IconButton
                          aria-label="Home"
                          icon={<IoHome size="3rem"/>}
                          onClick={navigateHome}
                          {...customButtonProps(isInAvataiSite())}
                          boxSize="4rem"
                        />
                      </Center>*/}
        </Container>

        <Image position="absolute"
          src="/images/51b7-15d0-10a4-f7ae.png"
          maxH="6rem" bottom="-16px" />
      </Box>
    </Container>
  )
}
export default memo(AutomatedTest);
